import { PageModule } from "@/routes/types";
import { loader } from "./loader";
import { Page } from "./page";

export default { name: "CompanyAdminTrustedEmailDomainsPage", loader, Page } as PageModule;
